import script from "./examQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./examQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./examQuestion.vue?vue&type=style&index=0&id=a903547c&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a903547c"]])

export default __exports__